import { isScrolledIntoView } from "./utilities";
import { isMobile } from "./utilities";

document.addEventListener("DOMContentLoaded", handleVideos);

function handleVideos() {
    const videos = document.querySelectorAll(".js-vimeo-cont");
    if (videos.length === 0) return;

    const vimeoScript = document.createElement("script");
    vimeoScript.src = "https://player.vimeo.com/api/player.js";

    document.body.appendChild(vimeoScript);

    window.addEventListener("load", () => {
        vimeoScript.addEventListener("load", createVimeoVideos(videos));
    });
}

const videoObserver = new window.IntersectionObserver(
    ([entry]) => {
        const targetInView = entry.intersectionRatio > 0;

        if (!targetInView) return;

        createVimeoPlayer(entry.target);
    },
    { threshold: 0.5 }
);

function createVimeoVideos(videos) {
    videos.forEach((video) => {
        videoObserver.observe(video);
    });
}

function createVimeoPlayer(video) {
    videoObserver.unobserve(video);

    const {
        dataset: { autoplay = false, vidIdMobile, vidId, hideControls },
    } = video;

    const videoOpt = {
        id: isMobile() && vidIdMobile ? vidIdMobile : vidId,
        controls: !hideControls,
        autoplay: autoplay,
        autopause: true,
        muted: autoplay,
        loop: autoplay,
    };

    const videoPlayer = new Vimeo.Player(video.id, videoOpt);

    videoPlayer.on("play", () => {
        window.dataLayer.push({ event: "gtm-video-play" });
    });

    const playBtn = video.querySelector(".js-play-btn");

    if (playBtn) {
        playBtn.addEventListener("click", () => {
            video.classList.add("playing");
            videoPlayer.play();
        });
    }

    window.addEventListener("carouselChanged", () => {
        stopVideo(video, videoPlayer);
    });

    if (autoplay) {
        isScrolledIntoView(video, () => {
            playPauseVideo(autoplay, videoPlayer);
        });
    }
}

function playPauseVideo(autoplay, player) {
    return (entry) => {
        if (autoplay) {
            entry.isIntersecting ? player.play() : player.pause();
        }
    };
}

function stopVideo(video, player) {
    const isPlaying = video.classList.contains("playing");
    if (!isPlaying) return;

    player.pause();
    player.setCurrentTime(0);
    video.classList.remove("playing");
}
